import 'babel-polyfill'

import {without, throttle, debounce} from 'lodash'
import 'reframe.js/dist/jquery.reframe.min'
import whatInput from 'what-input'

import './selects'
import './content'
import './load-more'
import './front-page'
import './header'
import './program-strip'
import './donate'
//import './preference-center'
import './popup'
import './programs'


import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";




jQuery('.content iframe').reframe()

jQuery(document).ready(function () {

    Fancybox.bind('[data-fancybox]', {
        //
    });

    jQuery(".jaotama__window-opener.copylink").click(function(event){
        var $copiedElement = jQuery("<span>");
        $copiedElement.addClass('copied-link').text('Copied!');
        jQuery('.jaotama__window-opener.copylink').append($copiedElement);
        $copiedElement.fadeIn(300);
        $copiedElement.fadeOut(1500);

   });

});
